import axios from '~/services/axios_auth'
import type {
  RFQRequestBody,
  AccumulatorRequestBody,
  SimmerringWidgetRequestBody
} from '~/types/mail-service.d'

export type {RFQRequestBody, AccumulatorRequestBody, SimmerringWidgetRequestBody}
export type {RFQRequestBodyPayload, AccumulatorRequestBodyPayload} from '~/types/mail-service.d'

export const useMailService = () => {
  const baseurl = useRuntimeConfig().public.BASIC_API_URL  || 'https://apim-enext-stg.azure-api.net'

  const mail_config_axios = axios.create({
    baseURL: useRuntimeConfig().public.MESSAGES_API || (baseurl + '/messages/1.0.0/mails')
  })

  const postRFQRequest = async function(requestBody: RFQRequestBody) {
    return mail_config_axios.post('', requestBody)
  }

  const postAccumulatorRequest = async function(requestBody: AccumulatorRequestBody) {
    return mail_config_axios.post('', requestBody)
  }

  const postSimmerringWidgetRequest = async function(requestBody: SimmerringWidgetRequestBody) {
    return mail_config_axios.post('', requestBody)
  }

  return {
    postRFQRequest,
    postAccumulatorRequest,
    postSimmerringWidgetRequest
  }
}
